import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceInfoService } from '../../../shared/services/device-info.service';
import { lastValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SopService {
  constructor(
    private http: HttpClient,
    private deviceInfoService: DeviceInfoService,
  ) {}

  getSOPs(params?: any) {
    return this.http
      .get(`/api/sop/`, { params: params })
      .pipe(map((response: any) => response));
  }

  async updateSOP(id: string, body: any, params?: any) {
    body = {
      ...body,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .put(`/api/sop/${id}/`, body, {
          params: params,
        })
        .pipe(map((response: any) => response)),
    );
  }
  retrieveSOP(id: string, params?: any) {
    const downloadHttpOption = {
      responseType: 'blob' as 'json',
      observe: 'response' as const,
    };
    return this.http.get(`/api/sop/${id}/`, downloadHttpOption);
  }
}
